import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d5fb912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content not-found items-in-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "not-found__404 medium third-color" }, "404", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xl-font-size-title-block medium third-color align-center" }, " Страница не найдена! ", -1))
const _hoisted_4 = { class: "mb--20 allBlockWidth" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "align-center" }, " Возможно, у вас опечатка в адресе страницы, или её просто не существует :( ", -1))

import { useRoute } from 'vue-router';
import { computed, onMounted, ref, watch } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { useOfferCardsStore } from '@/store/modules/offerCards';
import { OfferCardsBlock } from '@/components/Cards';
import { ResultCardType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {

const isLoading = ref(true);

const route = useRoute();
const topOfferCards = computed((): ResultCardType[] => {
  return useOfferCardsStore().topOfferCards;
});

onMounted(async () => {
  try {
    isLoading.value = true;
    await useOfferCardsStore().getTopOfferCards();
  } finally {
    isLoading.value = false;
  }
});
watch(
  () => route.name,
  () => {
    useAppStore().togglePageNotFound(false);
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (topOfferCards.value.length || isLoading.value)
        ? (_openBlock(), _createBlock(_unref(OfferCardsBlock), {
            key: 0,
            isLoading: isLoading.value,
            resultCards: topOfferCards.value,
            class: "mt--0",
            isTop: "",
            title: "Популярные объявления",
            "title-with-line": ""
          }, null, 8, ["isLoading", "resultCards"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5,
    _createVNode(_component_base_button, {
      href: { name: 'main' },
      text: "На главную"
    })
  ]))
}
}

})